import type { ComponentProps, ReactNode } from 'react';

import Editor from '@monaco-editor/react';

import { getTestProps } from '../../lib/helpers';

import HelpErrorTextsTemplate from '../HelpErrorTextsTemplate/HelpErrorTextsTemplate';

export type CodeEditorChangeFn = (value?: string) => void;

export interface CodeEditorProps extends ComponentProps<typeof Editor> {
  /**
   * On code editor value change callback
   */
  onChange?: CodeEditorChangeFn;
  /**
   * Additional caption description below editor code
   */
  caption?: ReactNode;
  /**
   * Default code editor value
   */
  defaultValue?: string;
  /**
   * Code editor value
   */
  value?: string;
  /**
   * Default code editor language
   */
  defaultLanguage?: string;
  /**
   * Code editor theme
   */
  theme?: string;
  /**
   * Code editor height
   */
  height?: string;
  /**
   * Code editor error
   */
  error?: unknown;
  /**
   * Component test id
   */
  testId?: string;
}

const CodeEditor = ({
  caption = '',
  onChange,
  value = '',
  defaultValue = '',
  defaultLanguage = 'javascript',
  theme = 'vs-dark',
  height = '40vh',
  error = '',
  testId = '',
  ...props
}: CodeEditorProps) => {
  return (
    <div
      className="bg-white dark:bg-slate-950"
      {...getTestProps(testId, 'container')}
    >
      <Editor
        height={height}
        theme={theme}
        defaultLanguage={defaultLanguage}
        defaultValue={defaultValue}
        value={value}
        onChange={onChange}
        {...getTestProps(testId, 'editor', 'testId')}
        {...props}
      />
      <HelpErrorTextsTemplate
        helpText={caption}
        error={error}
        additionalHelpClasses="text-slate-400"
        testId={testId}
      />
    </div>
  );
};

export default CodeEditor;
